import { addToSealedCollection, updateSealedCollectionItem, removeFromSealedCollection } from '@/services/api/sealed'
import { SEALED_MUTATION_KEYS, SEALED_SCOPE, SEALED_SETTLED_KEYS } from './collectionKeys'

/**
 * @public Never imported by name: consumed at runtime by `lib/offlineMutations.ts`
 * (import.meta.glob over hooks/**) — see collectionMutations above.
 */
export const sealedCollectionMutations = {
  add: {
    mutationKey: SEALED_MUTATION_KEYS.add,
    mutationFn: ({
      sealedProductId,
      data,
      idempotencyKey,
    }: {
      sealedProductId: number
      data?: { quantity?: number; notes?: string; acquiredPrice?: number }
      idempotencyKey?: string
    }) => addToSealedCollection(sealedProductId, data?.quantity, data?.acquiredPrice, data?.notes, idempotencyKey),
    offlineReplay: true,
    scope: SEALED_SCOPE,
    settledInvalidation: SEALED_SETTLED_KEYS,
  },
  update: {
    mutationKey: SEALED_MUTATION_KEYS.update,
    mutationFn: ({
      sealedProductId,
      data,
      idempotencyKey,
    }: {
      sealedProductId: number
      data: { quantity?: number; notes?: string | null; acquiredPrice?: number | null }
      idempotencyKey?: string
    }) => updateSealedCollectionItem(sealedProductId, data, idempotencyKey),
    offlineReplay: true,
    scope: SEALED_SCOPE,
    settledInvalidation: SEALED_SETTLED_KEYS,
  },
  remove: {
    mutationKey: SEALED_MUTATION_KEYS.remove,
    mutationFn: ({ id, idempotencyKey }: { id: number; idempotencyKey?: string }) =>
      removeFromSealedCollection(id, idempotencyKey),
    offlineReplay: true,
    scope: SEALED_SCOPE,
    settledInvalidation: SEALED_SETTLED_KEYS,
  },
}
